import { useDispatch, useSelector } from 'react-redux';
import { useLazyGetPromotionQuery } from './promotions.api';
import { setPromotionCode } from './promotions.slice';
import useAnalyticsEvents from '@/hooks/useAnalyticsEvents';
import useAddOns from '@/store/addons/useAddOns';

const usePromotions = () => {
  const dispatch = useDispatch();
  const promotions = useSelector((state) => state.promotions);
  const { ticketInsurance, eneableTicketInsurance } = useAddOns();
  const {
    event: { id },
  } = useSelector((state) => state.event || { event: {} });
  const event = useSelector((state) => state.event);
  const [trigger] = useLazyGetPromotionQuery();
  const { removePromotion, insuranceEneabled } = useAnalyticsEvents();

  const getPromotion = async (code, eventId) => {
    if (eventId || id) {
      const { data } = await trigger(
        {
          event: eventId || id,
          code,
        },
        true,
      );

      dispatch(setPromotionCode(data));
      // update OrderSummary
      return data;
    }
    return {};
  };

  const clearPromotion = () => {
    removePromotion(promotions.code);
    dispatch(setPromotionCode(null));
    if (
      ticketInsurance.disabled &&
      ticketInsurance.healthy &&
      promotions?.error
    ) {
      eneableTicketInsurance();
      insuranceEneabled({
        action: 'clear promotion',
      });
    }
  };

  return {
    getPromotion,
    clearPromotion,
    promotions,
  };
};

export default usePromotions;
